import { FC, useState } from 'react';
import { State } from 'redux/initialState';
import { useSelector } from 'react-redux';
import { useMixpanel } from 'react-mixpanel-browser';
import { Board, Council } from 'types';

import { deleteBoard } from 'modules/boards/utils';
import PageListHeader from 'modules/_shared/components/Headers/PageListHeader';
import { deleteCouncil } from 'modules/administratives/utils/deleteCouncil';
import { useGetBoardsSectionPermissions } from 'modules/boards/hooks/useGetBoardsSectionPermissions';

import { useTranslate } from 'hooks/useTranslate';
import { BoardEntityTypes } from 'types/Board';
import { boardEntityTypes } from '../BoardsListHeader/constants/boardEntityTypes';
import RecentBoardsSectionList from './components/RecentBoardsSectionList';
import CustomLoading from '../CustomLoading';

type RecentBoardsSectionProps = {
  boards: Council[] | Board[];
  boardType: BoardEntityTypes;
};

const RecentBoardsSection: FC<RecentBoardsSectionProps> = ({
  boards,
  boardType,
}) => {
  const { t } = useTranslate();

  const mixpanel = useMixpanel();

  const actualSociety = useSelector(
    (state: State) => state.society?.actualSociety
  );
  const user = useSelector((state: State) => state.user);

  const { isAdmin } = useGetBoardsSectionPermissions().data;

  const boardHeaderText =
    boardType === boardEntityTypes.COUNCIL ? 'RecentCouncils' : 'RecentBoards';

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleRemoveBoard = async (index: number) => {
    try {
      const board = boards[index];

      setIsLoading(true);

      switch (boardType) {
        case boardEntityTypes.COUNCIL:
          await deleteCouncil({
            council: board as Council,
            user,
            actualSociety,
            mixpanel,
          });
          break;
        case boardEntityTypes.BASIC_BOARD:
          await deleteBoard({
            board: board as Board,
            user,
            actualSociety,
            mixpanel,
          });
          setIsLoading(false);
          break;
        default:
          break;
      }
    } catch (error) {
      // setIsLoading(false);
    }
  };

  return (
    <>
      {isAdmin && (
        <PageListHeader
          subTitle={t(boardHeaderText)}
          subTitleClassName="fs-22px mt-2 mb-0"
        />
      )}

      <div className="nk-block council-recents-section">
        <div className="card bg-lighter rounded-xl">
          <RecentBoardsSectionList
            boards={boards}
            boardType={boardType}
            isAdmin={isAdmin}
            onRemoveBoard={handleRemoveBoard}
          />
        </div>
      </div>

      {isLoading && <CustomLoading />}
    </>
  );
};

export default RecentBoardsSection;
